import isType from './is-type';
export default (function (str) {
    return isType(str, 'String');
});
//# sourceMappingURL=is-string.js.map